import React, { useContext } from 'react';

// context
import { SideNavContext } from '../../SideNavBarLayout';

const HandledNavLink = ({ to, className, children }) => {
  const { handleLinkClick } = useContext(SideNavContext);

  const onClick = (event) => {
    event.preventDefault();
    handleLinkClick({ path: to, event });
  };

  return (
    <a href={to} onClick={onClick} className={className}>
      {children}
    </a>
  );
};

export default HandledNavLink;
